export const AnalyticsActionTypes = {
  SET_FETCHING_ANALYTICS: 'SET_FETCHING_ANALYTICS',
  FETCH_ANALYTICS_SUCCESS: 'FETCH_ANALYTICS_SUCCESS',
  FETCH_ANALYTICS_ERROR: 'FETCH_ANALYTICS_ERROR',

  RESET_ANALYTICS: 'RESET_ANALYTICS',
};
